import {
  BriefcaseIcon as DashboardIcon,
  SignalIcon as FeedIcon,
  ChatBubbleBottomCenterIcon as QuestionIcon,
  LinkIcon as IntegrationIcon,
  InboxIcon as FormIcon,
  FunnelIcon as FunnelIcon,
  UserCircleIcon as SegmentIcon,
  GiftIcon as CtaIcon,
  PuzzlePieceIcon as WidgetIcon,
  DocumentIcon as PagesIcon,
  WindowIcon as PersonalizationIcon,
  AtSymbolIcon as EmailIcon,
  BoltIcon as GoalIcon,
  ChartBarIcon as FunnelAnalysisIcon,
  BookOpenIcon as TemplatesIcon,
  ChatBubbleLeftRightIcon as SupportIcon,
  PresentationChartLineIcon as TestingIcon,
  FingerPrintIcon as AttributionIcon
} from '@heroicons/vue/24/outline'

const generateNavigation = () => {
  const integrationStore = useIntegrationStore()
  const { integratedPartner } = storeToRefs(integrationStore)

  const localDevelopment = import.meta.env.VITE_APP_ENV === 'development'

  return ref([
    {
      name: 'Dashboard',
      to: { name: ROUTES.DASHBOARD },
      icon: shallowRef(DashboardIcon)
    },
    {
      name: 'Live Feed',
      to: { name: ROUTES.FEED },
      icon: shallowRef(FeedIcon)
    },
    // {
    //   name: 'Templates',
    //   to: { name: ROUTES.TEMPLATES },
    //   icon: shallowRef(TemplatesIcon)
    // },
    {
      name: 'Enrich',
      type: 'divider'
    },
    {
      name: 'Segment Groups',
      to: { name: ROUTES.SEGMENTGROUPS },
      icon: shallowRef(SegmentIcon)
    },
    {
      name: 'Questions',
      to: { name: ROUTES.QUESTIONS },
      icon: shallowRef(QuestionIcon)
    },
    {
      name: 'Attribution',
      to: { name: ROUTES.ATTRIBUTION },
      icon: shallowRef(AttributionIcon)
    },
    {
      name: 'Integration',
      to: { name: ROUTES.INTEGRATIONS },
      icon: shallowRef(IntegrationIcon),
      aside: computed(() => {
        if (integratedPartner.value) {
          return `<img src="${integratedPartner.value.logo}" class="h-3.5 max-w-[70px] opacity-50 grayscale dark:invert" />`
        }
      })
    },
    {
      name: 'Convert',
      type: 'divider'
    },
    {
      name: 'Flows',
      to: { name: ROUTES.OFFERFUNNELS },
      icon: shallowRef(FunnelIcon)
    },
    {
      name: 'Widgets',
      to: { name: ROUTES.WIDGETS },
      icon: shallowRef(WidgetIcon)
    },
    {
      name: 'Pages',
      to: { name: ROUTES.METRICS },
      icon: shallowRef(PagesIcon),
      comingsoon: true
    },
    {
      name: 'Forms',
      to: { name: ROUTES.FORMS },
      icon: shallowRef(FormIcon)
    },
    {
      name: 'Offers & Promos',
      to: { name: ROUTES.OFFERS },
      icon: shallowRef(CtaIcon)
    },
    {
      name: 'Personalization',
      type: 'divider'
    },
    {
      name: 'Emails',
      to: { name: ROUTES.EMAILS },
      icon: shallowRef(EmailIcon),
      beta: true
    },
    {
      name: 'Website',
      to: { name: ROUTES.CAMPAIGNS },
      icon: shallowRef(PersonalizationIcon),
      permission: 'personalization-campaign'
    },
    {
      name: 'Conversion Goals',
      to: { name: ROUTES.GOALS },
      icon: shallowRef(GoalIcon),
      permission: 'personalization-campaign'
    },
    // {
    //   name: 'Phrases',
    //   to: { name: ROUTES.GOALS },
    //   icon: shallowRef(PhraseIcon)
    // },
    { name: 'Optimize', type: 'divider' },
    {
      name: 'Audience Insights',
      to: { name: ROUTES.INSIGHTS },
      icon: shallowRef(TemplatesIcon)
    },
    {
      name: 'A/B Testing',
      href: '#',
      icon: shallowRef(TestingIcon),
      comingsoon: true,
      permission: 'testing'
    },
    {
      name: 'Funnel Analysis',
      href: '#',
      icon: shallowRef(FunnelAnalysisIcon),
      comingsoon: true,
      permission: 'testing'
    },
    {
      name: 'Review Session',
      href: '#',
      icon: shallowRef(SupportIcon),
      comingsoon: true,
      permission: 'review'
    }
  ])
}

const generateUserNavigation = () => {
  const router = useRouter()
  const route = useRoute()
  const authStore = useAuthStore()
  return [
    {
      name: 'Your profile',
      action: () => {
        router.push({ name: ROUTES.PROFILE, query: { tab: 'profile' } })
      }
    },
    {
      name: 'Projects',
      action: () =>
        router.push({ name: ROUTES.PROFILE, query: { tab: 'projects' } })
    },
    {
      name: 'Billing',
      action: () =>
        router.push({ name: ROUTES.PROFILE, query: { tab: 'billing' } })
    },
    { name: 'Sign out', action: () => (window.location.href = '/logout') }
  ]
}

export { generateNavigation, generateUserNavigation }
